import React, { createContext, FC, PropsWithChildren, useContext, useMemo, useState } from "react"

export enum ETextType {
  DEFAULT = "DEFAULT",
  FREE_TRIAL = "FREE_TRIAL",
}

export type TTextType = (typeof ETextType)[keyof typeof ETextType]

type TContext = {
  selectedTextType: TTextType
  setSelectedTextType: (val: TTextType) => void
}

export const SelectedTextContext = createContext<TContext>({
  selectedTextType: ETextType.DEFAULT,
  setSelectedTextType: (val: TTextType) => {},
})

export const SelectedTextProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [selectedTextType, setSelectedTextType] = useState<TTextType>(ETextType.DEFAULT)

  return (
    <SelectedTextContext.Provider
      value={{
        selectedTextType,
        setSelectedTextType,
      }}
    >
      {children}
    </SelectedTextContext.Provider>
  )
}

export const useSelectedTextContext = () => useContext(SelectedTextContext)
